export const getDonationMessage = (donation = {}) => {
  const customMessage = donation?.custom_message;

  if (
    typeof customMessage === 'string' &&
    customMessage.trim().length > 0
  ) {
    return customMessage;
  }

  return donation?.message || '';
};
